import { httpClient } from '@/services/http/httpClient'

export type KnowledgeTrail = {
  type: string
  videoId: number
  description: string
  videoIdItem: number
  watched: boolean
  url: string
  fileName: string
  likes: number
  liked: boolean
  textExplanation: {
    id: string
    videoId: number
    title: string
    target: string
    mandatoryDiscussion?: string | null
    results?: string | null
    time?: string | null
  }
  commentListId?: string
}

type KnowledgeTrailRequest = {
  category: string
  videos: KnowledgeTrail[]
  watched: boolean
}

export type KnowledgeTrailResponse = {
  knowledgeTrail: KnowledgeTrailRequest[]
}

export async function getAllUserVideos(): Promise<KnowledgeTrailResponse> {
  const { data } =
    await httpClient.get<KnowledgeTrailRequest[]>('/users/videos')

  return {
    knowledgeTrail: data,
  }
}
